import BigNumber from 'bignumber.js';

BigNumber.config({ ROUNDING_MODE: BigNumber.ROUND_DOWN }); /** https://mikemcl.github.io/bignumber.js/#constructor-properties */

export default BigNumber;
